import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ABOVE-THE-FOLD relative text-white pl-5 md:pl-12 lg:pl-20 py-24 flex items-center" }
const _hoisted_2 = { class: "BLOCKS absolute pl-5 md:pl-0 w-full md:w-8/12 h-full top-0 right-0 z-10 overflow-hidden" }
const _hoisted_3 = { class: "BLOCK-ROW" }
const _hoisted_4 = { class: "BLOCK" }
const _hoisted_5 = { class: "BLOCK-ROW" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[120px]" }, null, -1)
const _hoisted_7 = { class: "BLOCK" }
const _hoisted_8 = { class: "BLOCK-ROW" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[240px]" }, null, -1)
const _hoisted_10 = { class: "BLOCK" }
const _hoisted_11 = { class: "BLOCK-ROW" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[300px]" }, null, -1)
const _hoisted_13 = { class: "BLOCK" }
const _hoisted_14 = { class: "BLOCK-ROW" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[350px]" }, null, -1)
const _hoisted_16 = { class: "BLOCK" }
const _hoisted_17 = { class: "BLOCK-ROW" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[300px]" }, null, -1)
const _hoisted_19 = { class: "BLOCK" }
const _hoisted_20 = { class: "BLOCK-ROW" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[350px]" }, null, -1)
const _hoisted_22 = { class: "BLOCK" }
const _hoisted_23 = { class: "BLOCK-ROW" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[280px]" }, null, -1)
const _hoisted_25 = { class: "BLOCK" }
const _hoisted_26 = { class: "BLOCK-ROW" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[400px]" }, null, -1)
const _hoisted_28 = { class: "BLOCK" }
const _hoisted_29 = { class: "BLOCK-ROW" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[300px]" }, null, -1)
const _hoisted_31 = { class: "BLOCK" }
const _hoisted_32 = { class: "BLOCK-ROW" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[200px]" }, null, -1)
const _hoisted_34 = { class: "BLOCK" }
const _hoisted_35 = { class: "BLOCK-ROW" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[100px]" }, null, -1)
const _hoisted_37 = { class: "BLOCK" }
const _hoisted_38 = { class: "BLOCK-ROW lg:!hidden" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "spacer min-w-[50px]" }, null, -1)
const _hoisted_40 = { class: "BLOCK" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-xl md:text-3xl opacity-75" }, "Ulixee 2.0"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-3xl md:text-6xl lg:text-7xl" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "md:block" }, "THE OPEN DATA"),
      /*#__PURE__*/_createTextVNode(" PLATFORM")
    ])
  ]),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "font-extralight w-7/12 md:w-5/12 text-md md:text-xl my-5" }, "Ulixee is creating an ecosystem where every website is an API and every developer can innovate new ideas atop the world’s data."),
  /*#__PURE__*/_createTextVNode()
], -1)
const _hoisted_42 = { class: "color-strip" }
const _hoisted_43 = { class: "grid grid-cols-1 md:grid-cols-3 bg-[#5D1166] text-white px-5 md:px-24 pt-16 pb-16 md:pb-28 gap-y-10 md:gap-x-20 text-center" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("header", { class: "font-extrabold text-xl my-1" }, [
  /*#__PURE__*/_createTextVNode("RELIABLE"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" WEB EXTRACTION")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-70 font-light" }, "Ulixee makes scrapers easier to write, faster to troubleshoot, and more reliable in production.", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("header", { class: "font-extrabold text-xl my-1" }, [
  /*#__PURE__*/_createTextVNode("INSTANT"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" MONETIZATION")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-70 font-light" }, "Ulixee's decentralized micro-payments convert your scripts into long-term revenue streams.", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("header", { class: "font-extrabold text-xl my-1" }, [
  /*#__PURE__*/_createTextVNode("EFFORTLESS "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("PRODUCTION SCALING")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-70 font-light" }, "Scaling from one to a thousand scrapers is easy with Ulixee’s public and private clouds.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, {
    class: "HOME-LAYOUT",
    showPadding: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[0], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(0, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[1], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(1, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[2], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(2, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[3], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(3, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[4], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(4, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[5], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(5, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[6], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(6, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[7], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(7, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[8], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(8, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[9], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(9, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[10], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(10, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[11], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(11, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createTextVNode(),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows[12], (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_inline_svg, {
                  src: _ctx.getLogo(12, i)
                }, null, 8, ["src"])
              ]))
            }), 256))
          ])
        ]),
        _createTextVNode(),
        _hoisted_41
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("ul", _hoisted_43, [
          _createElementVNode("li", null, [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/homepage-icons/reliable.svg'),
              height: "36",
              class: "inline-block mb-2"
            }, null, 8, ["src"]),
            _createTextVNode(),
            _hoisted_44,
            _createTextVNode(),
            _hoisted_45
          ]),
          _createTextVNode(),
          _createElementVNode("li", null, [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/homepage-icons/monetizable.svg'),
              height: "36",
              class: "inline-block mb-2"
            }, null, 8, ["src"]),
            _createTextVNode(),
            _hoisted_46,
            _createTextVNode(),
            _hoisted_47
          ]),
          _createTextVNode(),
          _createElementVNode("li", null, [
            _createVNode(_component_inline_svg, {
              src: require('@/assets/homepage-icons/scalable.svg'),
              height: "36",
              class: "inline-block mb-2"
            }, null, 8, ["src"]),
            _createTextVNode(),
            _hoisted_48,
            _createTextVNode(),
            _hoisted_49
          ])
        ])
      ]),
      _createTextVNode()
    ]),
    _: 1
  }))
}